module.exports = {
  pt_BR: {
    app: {
      name: 'My Heroes',
      heroes_grid: 'Marvel Heroes',
      description: 'Description',
      details: 'Hero Details',
      hero_comics: 'Hero comics',
      hero_comics_abbreviation: 'HQs',
      no_description: 'This Hero has no description',
      no_comics: 'This Hero has no comics',
      search: 'Search by initial letter',
    },
    info: {
      application: 'A project created with the intention of showing the resources developed during the mentoring.',
    },
    button: {
      go_to_grid: 'Go to Grid',
      back: 'Back',
    },
  },
};
